<template>
  <div class="gzLive_bodyMinHeight">
    <div class="gzLive-banner">
      <img
        src="https://www.cmef.com.cn/Content/Uploads/2025.03/48a44c78-a57d-46ec-b5f8-a9716b2c7517.png"
        alt=""
        style="width: 100%; height: 100%; object-fit: cover"
      />
    </div>

    <div class="gzLive-nav">
      <div
        class="gzLive-nav-item"
        :class="{ active: activeIndex == 0 }"
        @click="clickNavItem(0)"
      >
        媒体
      </div>
      <div
        class="gzLive-nav-item"
        :class="{ active: activeIndex == 1 }"
        @click="clickNavItem(1)"
      >
        直播速递
      </div>
      <div class="gzLive-nav-item" @click="clickOpenUrl()">经销商</div>
    </div>

    <div class="gzLive-content gzLive-media">
      <div
        class="gzLive-card"
        v-for="(item, index) in showList"
        :key="index"
        @click="clickOpenLink(item.Link)"
      >
        <div class="gzLive-card-img" style="background-color: #fff">
          <img
           :src=urlHttp+item.ImagePath
            alt=""
            style="width: 100%; height: 100%; object-fit: cover; border-radius: 10px"
          />
        </div>

        <div class="gzLive-card-text">
          <h2>
            {{ item.Title }}
          </h2>
          <p>
            {{ item.Summary }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
let moment = require("moment");
export default {
  name: "mobilePcLive",
  data() {
    return {
      activeIndex: 0,
      listLive: [],
      showList: [],
      urlHttp: "https://www.cmef.com.cn",
    };
  },

  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getActivityApiGetActivities: "exhibitionModule/getActivityApiGetActivities",
    }),

    async init() {
      let data = await this.getActivityApiGetActivities();
      if (data.length > 0) {
        this.listLive = data;
      }
      this.showType(1);
    },
    // 2025-3-8  页面显示的内容按照显示顺序从大到小去排列。点击新标签页跳转到配置的外链中。未配置的点击没反应即可。
    //    源文件在附件       页面上的媒体和直播速递是固定的展示这两个类型的直播活动，第三个”经销商“是固定的跳转一个外链地址：https://www.cmef.com.cn/BannnerJump/Activity
    showType(type) {
      this.showList = [];
      this.showList = this.listLive.filter((item) => item.Type == type);
    },

    clickNavItem(index) {
      this.activeIndex = index;
      this.showType(index == 0 ? 1 : 2);
    },
    clickOpenUrl() {
      window.open("https://www.cmef.com.cn/BannnerJump/Activity", "_blank");
    },

    clickOpenLink(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.gzLive_bodyMinHeight {
  min-height: 1800px;
  background: #fff;
}

.gzLive-banner {
  position: relative;
  width: 100%;
  height: 650px;
  background-color: #fff;
  overflow: hidden;
}

.gzLive-banner-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.gzLive-banner-content {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.gzLive-banner-content h1 {
  color: #fff;
  font-size: 48px;
  font-weight: bold;
}

.gzLive-nav {
  width: 1200px;
  margin: 20px auto;
  display: flex;
  justify-content: start;
  gap: 40px;
  padding: 20px 0;
  background: #fff;
  /* border-bottom: 1px solid #eee; */
}

.gzLive-nav-item {
  font-size: 16px;
  color: #666;
  cursor: pointer;
  padding: 10px 20px;
  width: 120px;
  text-align: center;
  background-color: #f7f7f7;
  border-radius: 20px;
}

.gzLive-nav-item.active {
  color: #fff;
  background: #17d0d2;
}

.gzLive-content {
  max-width: 1200px;
  margin: 0px auto;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 200px;
}
.gzLive-show {
  display: grid;
}
.gzLive-card {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 585px;
  cursor: pointer;
}

.gzLive-card-img {
  width: 100%;
  height: 330px;
  border-radius: 10px;
}

.gzLive-card-text h2 {
  font-size: 18px;
  height: 42px;
  color: #16d1d1;
  margin-bottom: 20px;
  line-height: 20px;
  border-bottom: 1px solid #e6e6e6;
  /* PC端一行溢出隐藏 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gzLive-card-text p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

@media screen and (max-width: 768px) {
  .gzLive_bodyMinHeight {
    min-height: 1000px;
    background: #fff;
  }

  .gzLive-banner {
    height: 125px;
  }

  .gzLive-banner-content h1 {
    font-size: 24px;
  }

  .gzLive-nav {
    width: 100%;
    margin: 0;
    padding: 15px 15px;
    overflow-x: auto;
    justify-content: center;
    gap: 10px;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .gzLive-nav-item {
    width: auto;
    min-width: 105px;
    padding: 8px 12px;
    font-size: 14px;
    flex-shrink: 0;
  }

  .gzLive-content {
    width: 100%;
    margin: 15px auto;
    padding: 0 15px;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .gzLive-card {
    gap: 8px;
  }

  .gzLive-card-img {
    height: calc(140vw / 3.9);
    border-radius: 8px;
  }

  .gzLive-card-text h2 {
    font-size: 13px;
    // height: 37px;
    margin-bottom: 8px;
    padding-bottom: 8px;
    /* 移动端二行溢出隐藏 */
    white-space: normal;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .gzLive-card-text p {
    font-size: 11px;
    line-height: 18px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

/* 针对更小屏幕的额外优化 */
@media screen and (max-width: 320px) {
  .gzLive-nav-item {
    min-width: 70px;
    padding: 6px 10px;
    font-size: 12px;
  }

  .gzLive-card-img {
    height: calc(160vw / 3.9);
  }
}
</style>
